import { Entity, LiveData } from '@toeverything/infra';

import type { TagStore } from '../stores/tag';
import { databaseTagColorToAffineLabel } from './utils';

export class Tag extends Entity<{ id: string }> {
  id = this.props.id;
  constructor(private readonly store: TagStore) {
    super();
  }

  private readonly tagOption$ = LiveData.from(
    this.store.watchTagInfo(this.id),
    undefined
  ).map(tagInfo => tagInfo);

  value$ = this.tagOption$.map(tag => tag?.value || '');

  color$ = this.tagOption$.map(
    tag => databaseTagColorToAffineLabel(tag?.color ?? '') || ''
  );

  createDate$ = this.tagOption$.map(tag => tag?.createDate || Date.now());

  updateDate$ = this.tagOption$.map(tag => tag?.updateDate || Date.now());

  rename(value: string) {
    this.store.updateTagInfo(this.id, {
      id: this.id,
      value,
      color: this.color$.value,
      createDate: this.createDate$.value,
      updateDate: Date.now(),
    });
  }

  changeColor(color: string) {
    this.store.updateTagInfo(this.id, {
      color,
    });
  }

  tag(pageId: string) {
    // sl-xbxb: Delegate to TagStore (handles Y.js local / GraphQL cloud)
    this.store.tagDoc(pageId, this.id);
  }

  untag(pageId: string) {
    // sl-xbxb: Delegate to TagStore (handles Y.js local / GraphQL cloud)
    this.store.untagDoc(pageId, this.id);
  }

  readonly pageIds$ = LiveData.from(this.store.watchTagPageIds(this.id), []);
}
